export enum ErrorCodesEnum {
  No = '0',
  OrganizerSharedGetActivityByQueryId = '3',
  OrganizerSharedHasActivity = '4',
  OrganizerSharedGetOrganizationByQueryId = '5',
  OrganizerSharedGetOrganizationFromAuthUser = '6',
  OrganizerSharedHasOrganization = '7',
}
